// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9y-3";
export var contentContainer = "_9y-0";
export var editorContainer = "_9y-1";
export var quillInputForm = "_9y-2";
export var zoneDivider = "_9y-4";